!(function () {
    "use strict";
    var e = {
            4105: function (e, t, r) {
                r.d(t, {
                    Ds: function () {
                        return c;
                    },
                    Q2: function () {
                        return n;
                    },
                    wz: function () {
                        return o;
                    },
                });
                const n = function () {
                        return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}` } };
                    },
                    o = async function () {
                        let e, t;
                        try {
                            e = await fetch(...arguments);
                        } catch (e) {
                            t = e;
                        }
                        return { response: e, error: t };
                    };
                function c(e, t) {
                    const r = this;
                    let n;
                    return function () {
                        for (var o = arguments.length, c = new Array(o), a = 0; a < o; a++) c[a] = arguments[a];
                        clearTimeout(n),
                            (n = setTimeout(function () {
                                return e.apply(r, c);
                            }, t));
                    };
                }
                document.querySelectorAll(".local-scroll").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        ((e) => {
                            Math.easeInOutQuad = function (e, t, r, n) {
                                return (e /= n / 2) < 1 ? (r / 2) * e * e + t : (-r / 2) * (--e * (e - 2) - 1) + t;
                            };
                            const t = document.getElementById("grid-archive-header"),
                                r = document.getElementById("nav-wrapper");
                            let n = 0,
                                o = 0;
                            t && (n = t.offsetHeight + 50), r && (o = r.offsetHeight + 50);
                            const c = e.offsetTop - n - o,
                                a = window.scrollY,
                                i = c - a;
                            let s = 0;
                            const l = () => {
                                s += 5;
                                const e = Math.easeInOutQuad(s, a, i, 200);
                                window.scrollTo(0, e), s < 200 && setTimeout(l, 5);
                            };
                            l();
                        })(document.querySelector(t));
                    });
                });
            },
        },
        t = {};
    function r(n) {
        var o = t[n];
        if (void 0 !== o) return o.exports;
        var c = (t[n] = { exports: {} });
        return e[n](c, c.exports, r), c.exports;
    }
    (r.d = function (e, t) {
        for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
        (r.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (function () {
            var e = r(4105);
            class t extends HTMLElement {
                constructor() {
                    super(),
                        (this.items = Array.from(this.querySelectorAll(".cart-item"))),
                        this.items.forEach((e) => this.manageState(e)),
                        (this.selectorsToUpdate = [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"]),
                        (this.mainCartSelector = ".shopify-section.cart"),
                        (this.miniCartSelector = "#mini-cart"),
                        (this.itemsContainersSelector = ".cart-items-container, .mini-cart--empty"),
                        (this.parser = new DOMParser());
                }
                manageState(e) {
                    const t = e.getAttribute('data-item-id');
                    var tt = e.querySelector('.data_matches');
                    var qty = tt.getAttribute('data-qty');
                    var idd = tt.getAttribute('data-id');
                    e.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click", () => {
                        this.changeCartItem({ id: t, quantity: 0 });
                    });
                    const r = e.querySelector('input[name="quantity"]');
                    if (!r) return;

                    r.addEventListener('change', (event) => {
                        this.changeCartItem({ id: t, quantity: parseInt(event.target.value) });
                    });

                    const n = e.querySelector('button[name="plus"]'),
                        o = e.querySelector('button[name="minus"]');
                    let c = parseInt(r.value);
                    n.addEventListener("click", () => {
                        var input = e.querySelector('input[name="quantity"]');
                        var vll = input.value;
                        if(vll == qty){
                        return false;
                        }
                        else{
                        (c += 1), (r.value = c);
                        this.changeCartItem({ id: t, quantity: c });
                        }
                    }),
                        o.addEventListener("click", () => {
                            (c -= 1), (r.value = c), this.changeCartItem({ id: t, quantity: c });
                        });
                }
                async changeCartItem(t) {
                    const { response: r, error: n } = await (0, e.wz)(`${routes.cartChange}`, { ...(0, e.Q2)(), body: JSON.stringify({ id: t.id, quantity: t.quantity, sections: "main-cart,navigation-main" }) });
                    if (n) return void console.error(n);
                    const o = await r.json(),
                        c = this.parser.parseFromString(o.sections["main-cart"], "text/html"),
                        a = this.parser.parseFromString(o.sections["navigation-main"], "text/html");
                    if (0 === o.item_count) {
                        document.querySelector(this.mainCartSelector) && (document.querySelector(this.mainCartSelector).innerHTML = c.querySelector(this.mainCartSelector).innerHTML);
                        const e = document.querySelector("#mini-cart");
                        e && (e.innerHTML = a.querySelector("#mini-cart").innerHTML);
                        const t = document.querySelector("drawer-component");
                        return t && (t.connect(), t.attachOverlay()), document.querySelectorAll("#mini-cart .icon").forEach((e) => e.classList.add("loaded")), void this.renderElements(c);
                    }
                    this.renderItems(c);
                }
                renderElements(e) {
                    this.selectorsToUpdate.forEach((t) => {
                        try {
                            const r = document.querySelectorAll(t),
                                n = e.querySelector(t);
                            r.length &&
                                n &&
                                r.forEach((e) => {
                                    n.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")), e.replaceWith(n.cloneNode(!0));
                                });
                        } catch (e) {
                            console.error(`Error updating ${t}`, e);
                        }
                    });
                    const t = e.querySelector(".cart-count");
                    document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach((e) => {
                        t ? (e.classList.contains("visually-hidden") && e.classList.remove("visually-hidden"), (e.textContent = t.textContent)) : e.classList.add("visually-hidden");
                    }),
                        document.querySelector("#cart-open-block .icon").classList.add("loaded");
                }
                renderItems(e) {
                    this.renderElements(e);
                    const t = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
                        r = e.querySelector(this.itemsContainersSelector);
                    t.forEach((e) => {
                        e && e.replaceWith(r.cloneNode(!0));
                    }),
                        document.querySelectorAll(".cart-item").forEach((e) => {
                            e.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")), this.manageState(e);
                        });
                }
            }
            customElements.get("cart-service") || customElements.define("cart-service", t),
                customElements.get("cart-note") ||
                    customElements.define(
                        "cart-note",
                        class extends HTMLElement {
                            constructor() {
                                super(),
                                    this.addEventListener(
                                        "change",
                                        (0, e.Ds)((t) => {
                                            const r = JSON.stringify({ note: t.target.value });
                                            fetch(`${routes.cart_update_url}`, { ...(0, e.Q2)(), body: r });
                                        }, 300)
                                    );
                            }
                        }
                    );
        })();
})();
